const colors = {
  candlestick: {
    rise: '#FF4141',
    fall: '#335CFF',
    even: '#FF4141',
  },
  pattern: {
    buying: '#FF414166',
    selling: '#335CFF44',
  },
}

export default colors
